import styled from 'styled-components';

interface ModalProps {
  isVisible: boolean
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background-color:  ${({ theme }) => theme.menuBackground};

    @media (max-width: 900px) {
      height: 100%;
    }

    @media (max-width: 900px) and (min-height: 885px) {
      height: 100vh;
    }

    @media (max-height: 656px) and (min-width: 550px) {
      height: 100%;
    }
`;

export const ModalTerms = styled.div<ModalProps>`
   display: ${(props) => props.isVisible ? 'flex' : 'none'};
   flex-direction: column;
   width: 100%;
   height: 100vh;
   background-color: rgba(0,0,0,0.2);
   align-items: center;
   justify-content: center;
   z-index: 2;
   position: absolute;

   @media (max-width: 900px) {
      height: 100%;
      background-color: transparent;
     }

   section {
     width: 55%;
     display: flex;
     flex: 1%;
     flex-direction: column;
     border-radius: 5px;
     max-height: 80vh;
     background-color: ${({ theme }) => theme.menuBackground};
     color: ${({ theme }) => theme.text};
     border: 2px solid ${({ theme }) => theme.text};

     @media (max-width: 1000px) {
      width: 65%;
     }

     @media (max-width: 900px) {
      width: 70%;
      height: 80%;
      box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.7);
     }

     @media (max-width: 800px) {
      width: 80%;
     }

     @media (max-width: 600px) {
      width: 90%;
     }

     header {
       display: flex;
       flex: 1;
       flex-direction: row;
       align-items: center;
       justify-content: space-between;
       padding: 5px 22px;

        h1 {
          font-size: 1.6rem;
          text-transform: uppercase;
          color: ${({ theme }) => theme.text};
        }

        h1:last-child {
          cursor: pointer;
          font-weight: bold;
          color: ${({ theme }) => theme.text};

          :hover {
            filter: brightness(1.2);
          }
        }
     }

     main {
       overflow-y: scroll;
       display: flex;
       flex: 8;
       padding: 5px 22px;
     }

     footer {
       display: flex;
       flex: 1.2;
       flex-direction: row;
       align-items: center;

       button {
         width: 100%;
         height: 100%;
         color: ${({ theme }) => theme.white};
         font-size: 1.3rem;
         text-transform: uppercase;
         letter-spacing:0.1rem;
         border-bottom: 2px solid ${({ theme }) => theme.text};
       }

       button:first-child {
         background-color: ${({ theme }) => theme.red};
       }

       button:last-child {
         background-color: ${({ theme }) => theme.purple};
       }

       button:hover {
         filter: brightness(1.2);
       }
     }
   }
`;

export const Content = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.menuHover};

  @media (max-width: 900px) {
      padding: 30px 0;
    }

  main, aside {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: auto;
    align-items: center;
    justify-content: center;

    img {
      width: 60%;
    }

    section {
      display: flex;
      flex-direction: row;
      width: 70%;
      text-align: start;
      margin-top: 8px;
      height: 25px;

      @media (max-width: 500px) {
        width: 80%;
      }

      @media (max-width: 360px) {
        width: 90%;
      }

      @media (max-height: 700px) {
        margin-top: 3px;
      }

      @media (max-height: 700px) and (max-width: 900px) {
        margin-top: 8px;
      }

      p, span {
        text-transform: uppercase;
        font-size: 1.2rem;
      }

      span {
        font-weight: bold;
        margin-left: 5px;
        cursor: pointer;
        color: ${({ theme }) => theme.text};

        :hover {
          text-decoration: underline;
        }
      }
    }

  }

  aside {
    height: 100%;
  }

  @media (max-width: 1050px) {
    main {
      flex: 6
    }

    aside {
      flex: 4;

      img {
        width: 70%;
      }
    }
  }

  @media (max-width: 900px) {
    main {
      flex: 7
    }

    aside {
      flex: 3;

      img {
        width: 100%;
      }
    }
  }

  @media (max-width: 1050px) {
    aside {
      display: none;
    }
  }
`;

export const LoginOptions = styled.div`
  width: 70%;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);

  @media (max-width: 500px) {
    width: 80%;
  }

  @media (max-width: 360px) {
    width: 90%;
  }

  @media (max-height: 700px) {
    margin-bottom: 8px;
  }

  @media (max-width: 900px) {
    margin-bottom: 20px;
  }

  button {
    background-color: ${({ theme }) => theme.white};
    width: 100%;

    h1 {
      display: flex;
      margin: auto;
      justify-content: center;
      padding: 10px 0;
      color: ${({ theme }) => theme.purple};

      @media (max-height: 700px) {
        padding: 7px 0;
      }

      @media (max-width: 900px) {
        padding: 10px 0;
      }
    }

    h1.spinner {
      animation: spin 1s infinite;

      @-moz-keyframes spin { 
      100% { -moz-transform: rotate(360deg); } 
      }
      @-webkit-keyframes spin { 
        100% { -webkit-transform: rotate(360deg); } 
      }
      @keyframes spin { 
        100% { 
          -webkit-transform: rotate(360deg); 
          transform:rotate(360deg); 
        } 
      }
    }

    :hover {
      background-color: ${({ theme }) => theme.purple};
      filter: brightness(1.3);
      transition: 0.7s ease;
      h1 {
        color: ${({ theme }) => theme.white};
      }
    }
  }
`;

export const FormWrapper = styled.div`
  width: 70%;
  margin: auto;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);
  text-align: start;

  @media (max-width: 500px) {
    width: 80%;
  }

  @media (max-width: 360px) {
    width: 90%;
  }

  label {
    display: block;
    text-transform: uppercase;
    letter-spacing:0.05rem;
    font-weight:bold;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.black};
    padding: 0;
    margin: 0;
    margin-bottom: -12px;
  }
  
  button {
    border: none;
    background-color:  ${({ theme }) => theme.purple};
    height: 40px;
    width: 100%;
    box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);

    color: ${({ theme }) => theme.white};
    font-size: 1.3rem;
    letter-spacing: 2px;
    text-transform: uppercase;

    :hover {
      filter: brightness(1.2);
      transition: 0.3s;
    }
  }
`;

export const DescriptionTerms = styled.div`
  display: flex;
  padding: 0 15px;
  margin-top: -4px;
  font-size: 1rem;
  align-items: center;

  input {
    cursor: pointer;
  }

  p, span {
    color: ${({ theme }) => theme.black};
  }

  p{
    margin: 0 7px;
  }

  span {
    font-weight: bold;
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  }
`